import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { NumberInputStyled } from 'approot/shared/styles/inputs.style';
import { FlexCentreAlign } from 'approot/shared/styles/flex.style';

export const RangeSettings = styled(FlexCentreAlign)`
  position: relative;
`;

export const RangeSettingsInput = styled(NumberInputStyled)``;

export const RangeSettingsPostfix = styled.div`
  margin-left: ${rem(3)};
`;
